import { defineNuxtPlugin } from 'nuxt/app'
import watermarkjs from 'watermarkjs'

export default defineNuxtPlugin(() => ({ provide: { watermarkjs } }))
